import { HStack, Text, VStack } from '@ayble-health/dashboard-components';
import { format, parseISO } from 'date-fns';
import { Spinner } from '@chakra-ui/react';
import styled from '@emotion/styled';
import FlashIconSVG from '../CustomSVGs/FlashIconSVG';
import { useUserFeedbackSurvey } from '../../api/healthCoach/useUserFeedback';
import { FEEDBACK_TYPE } from '../../models/userFeedback';
import { CONTENT_HEIGHT_PX } from './SurveyDisplay';

const JournalList = styled('div')`
  max-height: ${CONTENT_HEIGHT_PX}px;
  overflow: auto;
`;

export const JournalsDisplay = () => {
  const { userFeedbackSurveyData, isLoading, isError } = useUserFeedbackSurvey({
    survey_type: FEEDBACK_TYPE.DAILY_NOTE,
  });

  if (isLoading) return <Spinner my={4} />;

  if (isError) {
    return (
      <Text color={'red.500'}>
        There was an error while loading the journals, please try again later.
      </Text>
    );
  }

  const entries = userFeedbackSurveyData ?? [];

  return (
    <VStack>
      <VStack alignItems={'start'}>
        <HStack alignItems={'center'}>
          <FlashIconSVG />
          <Text
            color={'secondary.200'}
            fontSize={'md'}
            fontWeight={'normal'}
            ml={1}
          >
            Journals
          </Text>
        </HStack>
        <Text fontSize={'sm'} fontStyle={'italic'}>
          Daily journal entries
        </Text>
      </VStack>

      {entries.length ? (
        <JournalList>
          {entries.map(({ survey, feedback_day, created_at }, i) => {
            const note = survey?.note as string | undefined;
            if (!note) return null;

            const date = format(parseISO(feedback_day ?? created_at), 'MMM d, yyyy');

            return (
              <VStack key={i} pt={3} alignItems={'start'}>
                <Text fontSize={'md'} fontWeight={'semibold'}>
                  {date}
                </Text>
                <Text fontSize={'sm'} whiteSpace={'pre-wrap'}>
                  {note}
                </Text>
              </VStack>
            );
          })}
        </JournalList>
      ) : (
        <Text fontSize={'lg'} height={CONTENT_HEIGHT_PX} p={3}>
          📝 No journal entries yet
        </Text>
      )}
    </VStack>
  );
};
